// Import model
import { UpdateSectionRequest } from '../models/UpdateSectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateSfSectionRequest } from '../models/UpdateSfSectionRequest';

// Import dependency serializers (for complex types)
import { UpdateSfSectionRequestSerializer } from './UpdateSfSectionRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateSectionRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateSectionRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateSectionRequest instance
   */
  static deserialize(json: string): UpdateSectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateSectionRequest instance
   */
  static fromObject(obj: any): UpdateSectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateSectionRequest');
    }


    const instance: UpdateSectionRequest = {
      properties: obj['properties'] ? UpdateSfSectionRequestSerializer.fromObject(obj['properties']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateSectionRequest instances
   */
  static deserializeArray(json: string): UpdateSectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateSectionRequest instance to a JSON string
   */
  static serialize(instance: UpdateSectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateSectionRequest instance to a plain object
   */
  static toObject(instance: UpdateSectionRequest): any {
    return {
      'properties': instance.properties ? UpdateSfSectionRequestSerializer.toObject(instance.properties) : undefined,
    };
  }

  /**
   * Serializes an array of UpdateSectionRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateSectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
